import { sound } from '@pixi/sound';
import { InteractionEvent, Loader } from 'pixi.js';
import { logging, LOG_EVENT, LOG_SCENE } from '../api/log';
import { applyRanks } from '../api/rank';
import { Game, Scene, Store } from '../core';
import AllClearUI from '../ui/AllClearUI';
import NotificationNinimo from '../ui/NotificationNinimo';
import MainScene from './MainScene';

class AllClearScene extends Scene {
  private ui: AllClearUI;
  public notificationNinimo: NotificationNinimo;
  private notificationNinimoDT: number = 0;

  constructor(game: Game) {
    super(game);

    const button = document.getElementById('sharebtn') as HTMLElement;
    button.style.display = 'block';

    this.camera.setOffset({ x: 0, y: 0 });
    this.camera.setTargetPosition({ x: 540, y: 960 }, true);

    this.ui = new AllClearUI();
    this.ui.on('home', () => {
      const button = document.getElementById('sharebtn') as HTMLElement;
      button.style.display = 'none';
      this.game.changeScene(MainScene);
      logging(
        LOG_EVENT.GO_TO_HOME,
        LOG_SCENE.ALL_CLEAR_SCENE,
        Store.instance.data.playername,
        window.navigator.userAgent
      );
    });

    this.ui.scale.set(this.camera.zoom);
    this.ui.x = this.game.width / 2;
    this.ui.y = this.game.height / 2;

    this.container.addChild(this.ui);

    this.notificationNinimo = new NotificationNinimo();
    this.notificationNinimo.x = this.game.width - 10;
    this.notificationNinimo.y = this.game.height + this.notificationNinimo.height;
    this.container.addChild(this.notificationNinimo);

    this.notificationNinimoDT = 0;

    this.on('shared', () => {
      this.notificationNinimoDT = 120;
      logging(
        LOG_EVENT.COPY_SHARE,
        LOG_SCENE.ALL_CLEAR_SCENE,
        Store.instance.data.playername,
        window.navigator.userAgent
      );
    });
    logging(
      LOG_EVENT.GAME_START,
      LOG_SCENE.ALL_CLEAR_SCENE,
      Store.instance.data.playername,
      window.navigator.userAgent
    );
  }

  public update(elapsed: number): void {
    super.update(elapsed);
    this.ui.update(elapsed);

    this.notificationNinimo.x = this.game.width - 10;
    if (this.notificationNinimoDT > 0 && Math.abs(this.game.height - this.notificationNinimo.y) >= 1) {
      this.notificationNinimo.y += (this.game.height - this.notificationNinimo.y) * 0.1 * elapsed;
    } else if (this.notificationNinimoDT > 0) {
      this.notificationNinimo.y = this.game.height;
      this.notificationNinimoDT -= elapsed;
    } else if (
      this.notificationNinimoDT <= 0 &&
      Math.abs(this.game.height + this.notificationNinimo.height - this.notificationNinimo.y) >= 1
    ) {
      this.notificationNinimo.y +=
        (this.game.height + this.notificationNinimo.height - this.notificationNinimo.y) * 0.1 * elapsed;
    } else {
      this.notificationNinimo.y = this.game.height + this.notificationNinimo.height;
      this.notificationNinimoDT = 0;
    }
  }

  public static preload = async (callback: (currentValue: number, maxValue: number) => void): Promise<void> => {
    const assets: Array<string> = ['/audio/gameclear.mp3'];

    let maxLoaded = 1;
    for (const asset of assets) {
      if (!Loader.shared.resources[asset]) {
        Loader.shared.add(asset, asset);
        maxLoaded++;
      }
    }

    let loaded: number = 1;
    return new Promise((resolve) => {
      Loader.shared.onLoad.add(() => {
        callback(++loaded, maxLoaded);
      });
      Loader.shared.onComplete.once(() => {
        resolve();
      });
      Loader.shared.load();
    });
  };

  public destroy(): void {
    super.destroy();
  }

  protected pointerdown = (event: InteractionEvent) => {
    //
  };

  protected pointermove = (event: InteractionEvent) => {
    //
  };

  protected pointerup = (event: InteractionEvent) => {
    //
  };

  public async onBegin(): Promise<void> {
    sound.play('/audio/gameclear.mp3', { loop: false, volume: Store.instance.state.volume as number });

    let rank = -1;
    this.ui.setScore('ALL CLEAR', Store.instance.state.score.toString(), rank, Store.instance.data.playername);

    try {
      rank = await applyRanks(
        Store.instance.e(
          `ALL CLEAR,${Store.instance.state.score.toString()},${Store.instance.data.playername}`,
          '89Gr9JE3HLD0KEMeAsbKCC7XLts5552w'
        )
      );
    } catch (e) {
      console.error(e);
    }

    this.ui.setScore('ALL CLEAR', Store.instance.state.score.toString(), rank, Store.instance.data.playername);
  }
}

export default AllClearScene;
